import { render, staticRenderFns } from "./SuperTabs.vue?vue&type=template&id=4a325848&"
import script from "./SuperTabs.vue?vue&type=script&lang=tsx&"
export * from "./SuperTabs.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports